import {removeClass} from "../_vars";

export const advantagesFunc = () => {
   const advantagesMoreBtns = document.querySelectorAll(".sm-btn");
   [...advantagesMoreBtns].forEach(advantagesMoreBtn => {
      const advantagesHiddenText = advantagesMoreBtn.parentElement.querySelectorAll(
         ".sm-item.--hidden"
      );
      advantagesMoreBtn.addEventListener("click", (e) => {
         advantagesHiddenText.forEach((t) => removeClass(t, "--hidden"));
         advantagesMoreBtn.remove();
      });
   });
};
